import DateFormatter from './date-formatter'
import type Author from '../../interfaces/author'
import Link from "next/link";

type Props = {
    title: string
    coverImage: string
    date: string
    excerpt: string
    author: Author
    slug: string
}

const PostPreview = ({
                         title,
                         date,
                         excerpt,
                         slug
                     }: Props) => {
    return (
        <div className="my-3 bg-lightGrey">
            <div className="p-3">
                <h4>
                    <Link
                        as={`/posts/${slug}`}
                        href="/posts/[slug]"
                        target="_blank"
                        className=""
                    >
                        {title}
                    </Link>
                </h4>
                <div className="text-secondary mb-4">
                    <DateFormatter dateString={date}/>
                </div>
                <p className="text-primary mb-4">{excerpt}</p>
            </div>
        </div>
    )
}

export default PostPreview
